import React from 'react';

const Message = ({ message }) => {
  return (
    <div className={`message ${message.sender === 'user' ? 'user-message' : 'bot-message'}`}>
      <div className="message-content">
        <p className="mb-1" style={{whiteSpace: 'pre-wrap'}}>{message.text}</p>
        <small className="message-time">
          {message.timestamp.toLocaleTimeString('de-CH', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </small>
      </div>
    </div>
  );
};

export default Message;
